/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/13
 * Time: 10:54
 * Desc: 内部活动管理
 */
import { Component, Vue, Watch } from 'vue-property-decorator';
import collect from 'collect.js';
import axios from 'axios';
import type { ElForm } from 'element-ui/types/form';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { cloneDeep } from 'lodash';
import customerScreen from './customerScreen';
import { IPSService } from '@/services/ipsServices';
import { QinggerLibUtils, noop, showPlatform } from '@/util';
import { export_json_to_excel } from '@/library/sheet/Export2Excel';
import { Functions } from '@/library/utils/functions';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import { appEnvConfig } from '@/configs/appConfigs';
import PurchaseDetail from '@/views/components/purchaseDetail/purchaseDetail.vue';
import { EmpServiceAPIActions } from '@/services/empService';
import baseAPIService from '@/services/base/baseAPIService';
import couponLink from '@/views/components/linkForm/coupon';
import GenerateLink from '@/views/components/generateLink';
import ExportFile from '@/views/components/exportFile';
import Upload from '@/views/components/upload/upload.vue';

const isset = QinggerLibUtils.isset;

@Component({
  components: {
    Upload,
    NoAuth,
    PurchaseDetail,
    ExportFile,
  },
})
export default class InnerActivityManage extends Vue {
  /* 数据 */

  $refs: {
    form: ElForm;
  };

  /**
   * 网点列表
   * @type {any}
   */
  public siteList = [];

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 内部活动列表
   * @type {number}
   */
  public innerActivityList: Array<InnerActivityList> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 是否选中活动
   * @type {boolean}
   */
  public isSelected = false;

  /**
   * 关键字
   * @type {string}
   */
  public keyword = '';

  /** 活动类型
   * @type {string | number}
   */
  public activityType = '';

  /**
   * 活动类型
   * @type {ItemObject}
   */
  public actType: ItemObject = {};

  /**
   * 活动类型列表(API)
   * @type {any[]}
   */
  public actTypeList: ItemArray<ActType> = [];

  /**
   * 活动状态
   * @type {string}
   */
  public activityStatus = '';

  // 活动封面编辑展示
  editActShow = false;

  // 活动编辑内容
  editActContent: any = {
    actCover: '',
    actDetailPics: [],
  };

  actDetailPics = [];

  /**
   * 当前秒杀名称
   * @type {string}
   */
  public curSeckillName = '';

  /**
   * 有规格情况下秒杀活动的ID
   * @type {string}
   */
  public ruleSkId = 0;

  /**
   * 当前选中的秒杀活动的ID
   * @type {string}
   */
  public curSkId = 0;

  /**
   * 规格列表是否显示
   * @type {boolean}
   */
  public isScaleTableVisible = false;

  /**
   * 规格明细列表显示
   * @type {Array<ScaleList>}
   */
  public scaleList: Array<ScaleList> = [];

  /**
   * 订单明细列表是否显示
   * @type {boolean}
   */
  public isOrderDetailVisible = false;

  /**
   * 订单明细列表隐藏
   * @return null
   */
  public onOrderDetailListHide(): void {
    this.isOrderDetailVisible = false;
  }

  /**
   * 对话框的高度
   * @type {number}
   */
  public dialogWrapperHeight = 0;

  /**
   * 表格排序 1访问量倒序,2访问量正序，3分享倒序，4分享正序，5报名倒序，6报名正序
   * @type {number}
   */
  public tableSort = 0;

  /**
   * 选中活动ID
   * @type {number}
   */
  public choosedActId = 0;

  /**
   * 选中的网点Id
   * @type {number}
   */
  public chooseSiteId = 0;

  /**
   * 发送的抽中人数
   * @type {number}
   */
  public successOrderNumber = 0;

  /**
   * 抽取人数弹窗中选中要排除的的活动
   * @type {string}
   */
  public excludedActivityList: Array<number> = [];

  public defaultStart: Date | number;

  public defaultEnd: Date | number;
  /**
   * 该店铺其他活动列表
   * @type {Array<OtherActivityList>}
   */
  public otherActivityList: Array<OtherActivityList> = [];

  /**
   * 会员等级
   */
  public levelList: Array<{ cstLevelCode?: string; cstLevelName?: string }> = [];
  public selectLevel = '';

  /**
   * 是否显示二维码
   * @type {boolean}
   */
  public isShowCode = false;

  /**
   * 二维码路径
   * @type {string}
   */
  public imageView = '';

  /**
   * 列表请求参数
   * @type {ActivityRequestParam}
   */
  public requestParam: ActivityRequestParam = {};

  /**
   * 报名详情是否显示
   * @type {boolean}
   */
  public isShowEnroll = false;
  public actItem: ItemObject = {};
  public enlist: ItemArray<Enrolment> = [];
  public ruleList: ItemArray<Enrolment> = [];
  public enlistCount = 0;
  public enlistParam: EnlistParam = { cstLevelCode: '', chooseRadios: [] };
  public headColumnList: ItemArray<HeadColumn> = [];
  public enlistPage = 1;
  public chooseLengthPage = 1;
  public chooseLengthPageNum = 10;

  /**
   * 报名详情关键字
   * @type {string}
   */
  public enKeyword = '';

  /**
   * 抽中结果是否显示
   * @type {boolean}
   */
  public chooseResult = false;

  /**
   * 签到时间是否显示
   * @type {boolean}
   */
  public isShowCodeTime = false;

  public valueStime = '';
  public valueEtime = '';
  // 签到地点
  public signInAddress = '';

  public chooseResultList: Array<any> = [];
  public chooseResultTotal = 0;

  public dialogVisible_chooseLength = false;
  public dialogVisible_chooseLength_hasRule = false;

  public getNumber = 0;
  // protected getNumbers:string='';
  public dialogChooseLengthSelectValue = 9;
  public ruleChooseLengthSelectValue = '';
  public ruleChooseLengthInput = '';

  public centerDialogVisible = false;
  public isPostFlag = 9;
  public chooseSTime = '';

  public targetOrderCheck = 0; // 当前操作项的orderCheck
  // 搜索时间
  public date = [];
  /**
   * 是否已给未中签的用户发微信消息(0-未发， 1-已发)
   * @type {number}
   */
  public isSendUnLotteryMsg = false;

  // 时候对外展示

  public isShow = false;
  /**
   * 是否已给中签的用户发微信消息(0-未发， 1-已发)
   * @type {number}
   */
  public isSendLotteryMsg = false;

  public extrationNumData: ItemObject = { allCount: 0, lotteryCount: 0, cplId: 0, cplName: '', siteCode: '' };

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /**
   * 选中的活动
   * @type {any[]}
   */
  public multipleSelection: Array<any> = [];

  /**
   *  导出按钮的信息
   * @type {ItemObject}
   */
  public exportBtnInfo: ItemObject = {
    state: 0,
    url: '',
  };

  get exportParams() {
    const postParams = {
      exportType: 'act',
      params: {
        actIds: this.actIds,
        keyword: this.keyword,
        actTypeId: this.activityType ? Number.parseInt(this.activityType) : 0,
        actState: this.activityStatus === '' ? 0 : Number.parseInt(this.activityStatus),
      },
    };
    if (this.date && this.date.length) {
      postParams.params['startOfTime'] = moment(this.date[0]).format('YYYY-MM-DD');
      postParams.params['endOfTime'] = moment(this.date[1]).format('YYYY-MM-DD');
    }
    return postParams;
  }

  /**
   * 文件上传地址
   * @type {string}
   */
  fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  /**
   * token
   * @type {{Authorization: string}}
   */
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  corpId = baseAPIService.resolveCorpId();

  /**
   * 选取开始时间
   * @type {any}
   */
  public pickerBeginDateBefore: any = {
    disabledDate: (time) => {
      this.chooseSTime = time.getTime();
      return time.getTime() + 24 * 60 * 60 * 1000 <= Date.now();
    },
  };

  /**
   * 选取结束时间
   * @type {any}
   */
  public pickerBeginDateAfter: any = {
    disabledDate: (time) => {
      return time.getTime() + 24 * 60 * 60 * 1000 < Date.now();
    },
  };

  // 日期切换
  public dateChange() {
    this.page = 1;
    this.getActivityList();
  }

  /**
   * 是否不能抽奖
   * @type {boolean}
   */
  public isCanChou = true;

  public orderFormChooseList: Array<ActTypeColumns> = [];
  public orderSkuItems: Array<ActTypeColumns> = [];

  /**
   * socket连接准备
   * @type {boolean}
   */
  public isSocketReady = false;

  /**
   * 确认抽取弹窗显示
   * @type {boolean}
   */
  public isShowConfirm = false;

  /**
   * 输入确认信息
   * @type {string}
   */
  public inpumConfirm = '';

  /**
   * 验证规则
   */
  public rules: ItemObject = {
    inpumConfirm: [{ validator: this.v_inputConfirm, trigger: 'blur' }],
  };

  /**
   * 抽取总数
   */
  public totalChouqu = 0;

  /**
   * 是否开始抽签限制
   */
  public isOpenActTimeFilter = false;

  /**
   * 是否限制
   */
  public isAstrict = 0;

  /**
   * 消费时间
   */
  public consumeTime: any = '';

  public pickerOptions = {
    disabledDate(time) {
      return time.getTime() > Date.now();
    },
  };

  // 文件名
  public fileName = '';

  // 导入的文件
  public importFile: any = {};

  // 是否开启顾客筛选
  public isCustomerScreen = false;

  // 选中的活动id

  public actIds = [];

  // 已上传会员数
  public memberNum = 0;

  // 是否已上传
  public isUploadOver = false;

  // 临时表名称
  public tableName = '';

  // 上传中的状态
  public uploadLoading = false;

  // 标签列表
  public tagList: ItemArray = [];

  // 最大数量
  public maxNumber = 0;

  // sendToId
  public sendToId = `${appEnvConfig.NODE_ENV}InnerActivityManage${this.$store.state.empCode}${Date.now()}`;

  // 抽取总人数
  public chouQuCount = '0';

  // 已抽中人数
  public chouQuNumber = 0;

  // 抽取状态
  public chouQuLoading = null;
  // 选中的优惠券
  public selectedCoupon = { cplId: 0, cplName: '' };

  // 1 老门户 2 新门户
  public platformVersion = '';

  /* 方法 */

  /**
   * 监听弹窗清空输入框内容
   */
  @Watch('isShowConfirm')
  watchShowConfirm(newVal) {
    if (!newVal) {
      this.inpumConfirm = '';
    }
  }

  @Watch('dialogVisible_chooseLength')
  watchDialogVisible_chooseLength(n) {
    if (!n) {
      this.uploadLoading = false;
      this.isUploadOver = false;
      this.tableName = '';
      this.exportBtnInfo = { state: 0, url: '' };
      this.resetSocket();
      this.fileName = '';
      this.importFile = {};
      this.getNumber = 0;
      this.excludedActivityList = [];
      this.selectLevel = '';
      this.isAstrict = 0;
      this.consumeTime = '';
      this.tagList = [];
      this.maxNumber = 0;
    }
    // else {
    //     this.resetSocket(`${appEnvConfig.NODE_ENV}MemberScreen${this.$store.state.empCode}`);
    // }
  }

  @Watch('dialogVisible_chooseLength_hasRule')
  watchDialogVisible_chooseLength_hasRule(n) {
    if (!n) {
      this.uploadLoading = false;
      this.isUploadOver = false;
      this.tableName = '';
      this.exportBtnInfo = { state: 0, url: '' };
      this.resetSocket();
      this.fileName = '';
      this.importFile = {};
      this.selectLevel = '';
      this.isAstrict = 0;
      this.consumeTime = '';
      this.tagList = [];
      this.maxNumber = 0;
    }
    // else {
    //     this.resetSocket(`${appEnvConfig.NODE_ENV}MemberScreen${this.$store.state.empCode}`);
    // }
  }

  @Watch('name')
  watchShowCodeTime(n) {
    if (!n) {
      this.selectedCoupon = { cplId: 0, cplName: '' };
    }
  }

  consumeTimeChange() {
    this.$nextTick(() => {
      if (this.consumeTime) {
        const tempDate = new Date((this.consumeTime[1] as Date).getTime());
        tempDate.setMonth(tempDate.getMonth() - 3);
        if ((this.consumeTime[0] as Date).getTime() < tempDate.getTime()) {
          this.$message.warning('最大间隔3个月');
          this.consumeTime = '';
        }
      }
    });
  }

  /**
   * 验证是输入内容是否相同
   */
  public v_inputConfirm(rule, value, callback) {
    if (value !== `确定抽取${this.targetOrderCheck == 2 ? this.getNumber : this.totalChouqu}人`) {
      callback(new Error('文本不匹配'));
    } else {
      callback();
    }
  }

  /**
   * 活动类型切换
   * @param {string} val
   * @return null
   */
  public onActivityChange(val: string): void {
    this.actType = this.actTypeList.filter((item) => {
      return item.actTypeId === val;
    });
    this.activityType = val;
    this.page = 1;
    this.pageSize = 10;
    this.getActivityList();
  }

  /**
   * 活动状态切换
   * @param {number} val
   */
  public onActivityStateChange(val: number): void {
    this.page = 1;
    this.pageSize = 10;
    this.getActivityList();
  }

  /**
   * 获得活动类型列表
   * @return null
   */
  public getActTypeList(): void {
    const queryParams = {
      isTitle: 1,
    };
    IPSService.getActTypeList({ queryParams })
      .then((res) => {
        if (res.count > 0) {
          this.actTypeList = res.list;
        } else {
          this.actTypeList = [];
          this.$message.warning('未检索到活动类型列表');
        }
      })
      .catch((err) => {
        console.log('------------------------->', err);
      });
  }

  public onLink(item) {
    GenerateLink.open({
      item,
      title: '生成活动链接',
      type: 'activity',
      confirm: false,
      remarkList: ['注1：此链接可用于公众号的图文链接中，点击图文可跳转到发售活动报名页面；'],
    }).then(noop, noop);
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getActivityList();
  }

  /**
   * 页码变更
   * @param {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getActivityList();
  }

  public targetSku = ''; // 当前查看规格
  /**
   * 选中的活动
   * @param val
   * @return null
   */
  public onHandleSelectionChange(val): void {
    this.actIds = val.map((i) => {
      return i.actId;
    });
    this.multipleSelection = val;
    this.isSelected = val.length > 0;
  }

  /**
   * 关键字搜索
   * @return null
   */
  public onSearchActivity(): void {
    this.page = 1;
    this.pageSize = 10;
    this.getActivityList();
  }

  /**
   * 排序
   * @param val
   * @return null
   */
  public onSortChange(val): void {
    // 1访问量倒序,2访问量正序，3分享倒序，4分享正序，5报名倒序，6报名正序
    switch (`${val.prop}-${val.order}`) {
      case 'seeNum-ascending':
        this.tableSort = 1;
        break;
      case 'seeNum-descending':
        this.tableSort = 2;
        break;
      case 'shareNum-ascending':
        this.tableSort = 3;
        break;
      case 'shareNum-descending':
        this.tableSort = 4;
        break;
      case 'orderNum-ascending':
        this.tableSort = 5;
        break;
      case 'orderNum-descending':
        this.tableSort = 6;
        break;
      case 'orderLotteryNum-ascending':
        this.tableSort = 7;
        break;
      case 'orderLotteryNum-descending':
        this.tableSort = 8;
        break;
      case 'addTime-ascending':
        this.tableSort = 7;
        break;
      case 'addTime-descending':
        this.tableSort = 8;
        break;
    }
    this.page = 1;
    this.pageSize = 10;
    this.getActivityList();
  }

  /**
   * 获取活动列表
   * @return null
   */
  public getActivityList(): void {
    const me = this;
    const postParams = {
      actTypeId: this.activityType ? Number.parseInt(this.activityType) : 0,
      page: this.page, // 页数
      pageNum: this.pageSize, // 每页个数
      actState: this.activityStatus === '' ? 0 : Number.parseInt(this.activityStatus), // 状态 0全部1未开始、2进行中、3已结束、4已下架、5未发布,6管理员下架（4已下架包含管理员下架）
      keyword: this.keyword, // 活动名称
    };
    if (this.date && this.date.length) {
      postParams['startOfTime'] = moment(this.date[0]).format('YYYY-MM-DD');
      postParams['endOfTime'] = moment(this.date[1]).format('YYYY-MM-DD');
      if (this.date[1] - this.date[0] > 184 * 24 * 3600 * 1000) {
        this.$message.error('更新时间跨度不能超过6个月！');
        this.date = [this.defaultStart, this.defaultEnd];
        postParams['startTime'] = moment(this.date[0]).format('YYYY-MM-DD');
        postParams['endTime'] = moment(this.date[1]).format('YYYY-MM-DD');
        this.ipsGetList(postParams);
        return;
      }
    }
    this.ipsGetList(postParams);
  }

  ipsGetList(postParams) {
    IPSService.getActivityList({ postParams })
      .then((res) => {
        if (res && res.list && res.list.length) {
          res.list.forEach((item: ItemObject) => {
            item.addTime = Functions.timeFormat(item.addTime);
          });
        }
        this.innerActivityList = res.list;
        const list = ['really', 'footmark', 'ruilijxs', 'demoenv', 'devtest2'];

        showPlatform(list) ? this.$set(this.innerActivityList, 'isShow', true) : this.$set(this.innerActivityList, 'isShow', false);

        this.totalCount = res.count;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  /**
   * 获取活动报名人员列表
   * @param item
   * @return null
   */
  public onShowRecruitList(item): void {
    this.actItem = item;
    this.enlistParam.actId = item.actId;
    this.enlistParam.page = 1;
    this.enlistPage = 1;
    this.enlistParam.pageNum = 10;
    this.enlist = [];
    this.choosedActId = item.actId;
    this.adminActOrderChooseList();
    // this.getOtherActivityList(); // 获取该店铺其他活动的列表
    this.getLevelList();
    this.getHeaderList(1)
      .then(() => {
        this.isShowEnroll = true;
      })
      .catch((err) => {
        throw err;
      }); // 获取表头
    this.getEnlist(); // 获取人员列表
  }

  /**
   * 获取规格列表明细显示
   * @param item
   * @return null
   */
  public onShowRuleList(item: ItemObject, id: Number): void {
    // this.getSkidList();//获取秒杀活动查看需要
    this.isScaleTableVisible = true;
    this.curSeckillName = item.secKillName;
    this.scaleList = item.skuItems;
    this.ruleSkId = item.skId;
    this.getRuleList();
  }

  /**
   * 规格明细列表隐藏
   * @return null
   */
  public onRuleListHide(): void {
    this.isScaleTableVisible = false;
    this.scaleList = [];
    this.curSeckillName = '';
  }

  /**
   * 购买明细列表显示
   * @return null
   */
  public onOrderDetailListShow(item): void {
    this.isOrderDetailVisible = true;
    this.curSeckillName = item.secKillName;
    this.curSkId = item.skId;
    // 算出的值在子组件中使用
    setTimeout(() => {
      const orderDetailWrapper = document.querySelector('#orderDetailWrapper');
      // @ts-expect-error
      this.$store.commit('onDialogHeightModify', orderDetailWrapper.offsetHeight);
      window.onresize = () => {
        // @ts-expect-error
        this.$store.commit('onDialogHeightModify', orderDetailWrapper.offsetHeight);
      };
      // @ts-expect-error
      this.$refs.PurchaseDetail.onClearData(); // 清除组件数据
      // @ts-expect-error
      this.$refs.PurchaseDetail.getOrderDetailList(); // 获取秒杀订单列表
    }, 100);
  }

  /**
   * 获取表格表头
   * @param source 1 报名 2 中签
   */
  public getHeaderList(source: number) {
    return new Promise((resolve) => {
      const postParams = {
        actId: this.choosedActId,
        source,
      };
      IPSService.getTitleList({ postParams }).then((responseData) => {
        if (isset(responseData, 'list')) {
          const list = responseData.list.map((i) => {
            i.isShowBuyPhone = i.key == 'buy_phone';
            i.isShow = i.key == 'mobile';
            i.isShowName = i.key == 'real_name';
            return i;
          });
          if (list.some(v => v.key.match('citypicker'))) {
            const index = list.findIndex(v => v.key.match('citypicker'));
            list.splice(index, 1, {
              key: 'province',
              title: '地址-省',
            }, {
              key: 'city',
              title: '地址-市',
            }, {
              key: 'area',
              title: '地址-区',
            });
          }
          this.headColumnList = list;
          resolve(this.headColumnList);
        } else {
          this.$message.warning('未获取到报名模板配置');
        }
      });
    });
  }

  /**
   * 获取具体报名人员名单
   * @return null
   */
  public getEnlist(): void {
    const postParams = Object.assign({}, this.enlistParam);
    if (!postParams.cstLevelCode) {
      delete postParams.cstLevelCode;
    }
    postParams.chooseRadios
    && (postParams.chooseRadios = postParams.chooseRadios.filter((item) => {
      return item !== '不限';
    }));
    IPSService.getPersonList({ postParams }).then((res) => {
      this.enlistCount = res.count;
      this.enlist = this.dealList(res.list).map((enItem: any) => {
        enItem.orderSpec = Functions.emptyVaribleHandler(enItem.orderSpec);
        return enItem;
      });
      if (!this.isShowEnroll && res.count <= 0) {
        this.$message.warning('未检索到报名人员');
      }
    });
  }

  /**
   * 清除报名列表搜索记录
   */
  public onClearEnData(): void {
    this.isShowEnroll = false;
    this.enlistParam.keyword = '';
    this.enKeyword = '';
    this.isShowConfirm = false;
    this.dialogVisible_chooseLength_hasRule = false;
    this.dialogVisible_chooseLength = false;
    this.getActivityList();
  }

  /**
   * 当前输入的留言关键字
   * @return null
   */
  public onGetEnrollWord(): void {
    this.enlistParam.keyword = this.enKeyword;
    this.enlist = [];
    this.enlistParam.page = 1;
    this.enlistPage = 1;
    this.getEnlist();
  }

  /**
   * 下载excel
   */
  public onDownloadSheet(flag) {
    const postParams = {
      actId: this.actItem.actId,
    };

    if (flag == 'a') {
      postParams['hidePhone'] = 0;
    } else if (flag == 'b') {
      postParams['hidePhone'] = 1;
    }
    IPSService.getPersonList({ postParams }).then((responseData) => {
      if (responseData.list?.length > 0) {
        require.ensure([], () => {
          const tHeader = collect(this.headColumnList).pluck('title').toArray();
          const filterVal = collect(this.headColumnList).pluck('key').toArray();
          const list = this.dealList(responseData.list);
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, `报名列表-${this.actItem.actTitle}`);
        });
      } else {
        this.$message.error('暂无待下载的数据');
        return;
      }
    });
  }

  dealList(list) {
    return list.map((enItem: any) => {
      const keys = Object.keys(enItem);
      const name = keys.find(v => v.match('citypicker'));
      if (name) {
        const addressList = enItem[name]?.split(' ');
        enItem.province = addressList[0];
        enItem.city = addressList[1];
        enItem.area = addressList[2];
      }
      return enItem;
    });
  }

  /**
   * 下载excel
   */
  public onDownloadSheet2(flag) {
    const postParams = {
      actId: this.choosedActId,
      isPost: this.isPostFlag,
    };
    if (flag == 'a') {
      postParams['hidePhone'] = 0;
    } else if (flag == 'b') {
      postParams['hidePhone'] = 1;
    }
    IPSService.getExtractionList({ postParams }).then((responseData) => {
      if (responseData.list?.length > 0) {
        require.ensure([], () => {
          this.headColumnList = this.headColumnList.filter((item) => {
            return item.key != 'isPost';
          });
          this.headColumnList.push({ key: 'isPost', title: '状态' });

          const tHeader = collect(this.headColumnList).pluck('title').toArray();
          const filterVal = collect(this.headColumnList).pluck('key').toArray();
          const list: any = this.dealList(responseData.list);
          list.forEach((item, idx) => {
            list[idx].isPost = item.isPost == 1 ? '已发送' : '未发送';
          });
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, '抽中报名列表');
        });
      } else {
        this.$message.error('暂无待下载的数据');
        return;
      }
    });
  }

  /**
   * 将数组处理成索引数组
   * @param filterVal
   * @param jsonData
   * @returns {any}
   */
  public formatJson(filterVal, jsonData) {
    return jsonData.map(v => filterVal.map(j => v[j]));
  }

  /**
   * 报名表格当前页
   * @param val
   */
  public handleENCurrentChange(val) {
    this.enlistPage = val;
    this.enlistParam.page = val;
    this.getEnlist();
  }

  /**
   * 每页显示条数
   * @param val
   */
  public selectedEnPageNum(val) {
    this.enlistParam.pageNum = val;
    this.enlistParam.page = 1;
    this.enlistPage = 1;
    this.getEnlist();
  }

  /**
   * 清除定时器
   */
  public closeTimer() {
    this.isShowCode = false;
    this.isShowCodeTime = false;
  }

  /**
   * 抽中人数
   * @return null
   */
  public onGetChooseRow(row): void {
    this.choosedActId = row.actId || 0;
    this.successOrderNumber = row.count || 0;
    this.isSendUnLotteryMsg = !!(row.isSendUnLotteryMsg || 0);
    this.isSendLotteryMsg = !!(row.isSendLotteryMsg || 0);

    const postParams = { actId: Math.trunc(this.choosedActId) }; // 活动ID
    IPSService.getExtractionNum({ postParams })
      .then((res) => {
        this.extrationNumData = Object.assign({}, { siteCode: row.siteCode }, res);
        this.selectedCoupon = { cplId: this.extrationNumData.cplId, cplName: this.extrationNumData.cplName };
        this.signInAddress = res.siteAddress;
        this.adminActOrderChooseList();
        // this.getOtherActivityList(); // 获取该店铺其他活动的列表
        this.getLevelList();

        this.ruleSkId = row.skId;
        this.getRuleList();
        this.getChooseLengthConfirm();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  /**
   * 获取抽中人数列表
   * @return null
   */
  public getChooseLengthConfirm(): void {
    this.getHeaderList(2).then(() => {
      const postParams = {
        actId: this.choosedActId || 0, // 活动ID
        // getNumber     : 0,      //抽取人数
        hidePhone: 1, // 1手机号码加密
        isPost: this.isPostFlag, // 是否已发送 1发送 0木有 不传或者9代表全部
        page: this.chooseLengthPage,
        pageNum: this.chooseLengthPageNum,
      };
      // if(this.targetSku){
      postParams['sku'] = this.targetSku || '';
      // }
      IPSService.getExtractionList({ postParams }).then((res) => {
        this.isSendUnLotteryMsg = !!res.isSendUnLotteryMsg;
        this.chooseResultList = this.dealList(res.list).map((chooseItem: any) => {
          chooseItem.orderSpec = Functions.emptyVaribleHandler(chooseItem.orderSpec);
          return chooseItem;
        });
        this.chooseResultTotal = res.count;
        this.successOrderNumber = res.unPostCount || 0;
        this.chooseResult = true;
        this.dialogVisible_chooseLength_hasRule = false;
      });
    });
  }

  // 确认收取之前
  beforeConfirmChouQu() {
    if (!this.isUploadOver && this.fileName) {
      this.$confirm('框定可中签用户中的文件尚未上传，是否确认抽签？', { type: 'warning' }).then((result) => {
        if (result === 'confirm') {
          this.postChooseLengthConfirmRule();
        }
      }, noop);
    } else {
      this.postChooseLengthConfirmRule();
    }
  }

  composeValue(type) {
    return {
      key: type,
    };
  }

  offlineSettlement(key) {
    const actIdList = collect(this.multipleSelection).pluck('actId').toArray();
    const postParams = {
      actIds: actIdList,
      isShowVendor: key.key,
    };
    if (postParams.actIds === []) {
      this.$message.error('请选择要更新的内容');
    } else {
      if (key.key === 0) {
        this.$confirm('确认要将选中项设置为对外不展示吗？', { type: 'warning' }).then((res) => {
          if (res === 'confirm') {
            IPSService.actVendorState({ postParams }).then((res) => {
              if (res.result) {
                this.$message.success('设置成功');
                this.getActivityList();
              } else {
                this.$message.error('操作失败');
              }
            });
          }
        }, noop);
      } else if (key.key === 1) {
        this.$confirm('确认要将选中项设置为对外展示吗？', { type: 'warning' }).then((res) => {
          if (res === 'confirm') {
            IPSService.actVendorState({ postParams }).then((res) => {
              if (res.result) {
                this.$message.success('设置成功');
                this.getActivityList();
              } else {
                this.$message.error('操作失败');
              }
            });
          }
        }, noop);
      }
    }
  }

  /**
   * 抽中人数有限制
   * @return null
   */

  public postChooseLengthConfirmRule(): void {
    let showConfirm = false;
    if (this.targetOrderCheck == 2) {
      if (this.getNumber <= 0 || !this.getNumber || !(`${this.getNumber}`).trim()) {
        this.$message.warning('请输入抽取人数');
        return;
      }
    } else if (this.targetOrderCheck == 1) {
      const ispass
        = this.orderSkuItems.some((el: ItemObject) => {
          return el.choosePeopleNum >= 1;
        })
        && this.orderSkuItems.every((el: ItemObject) => {
          return el.choosePeopleNum >= 0;
        });

      this.totalChouqu = 0;
      this.orderSkuItems.forEach((v: ItemObject) => {
        this.totalChouqu += Number(v.choosePeopleNum);
      });
      // 抽取数量最大不做限制 在超出范围后提示 范围为 0 ~ (库存和库存减去已抽取人数中的最小值)
      const isOver = this.orderSkuItems.some((v: ItemObject) => {
        let result = v.choosePeopleNum > v.totalStock || v.choosePeopleNum > v.totalStock - v.luckyNum;
        if (!v.choosePeopleNum) {
          result = false;
        }
        return result;
      });
      if (ispass && isOver) {
        showConfirm = true;
      }
      if (!ispass) {
        this.$message.warning('请输入抽取数量');
        return;
      }
    } else if (this.isOpenActTimeFilter && this.isAstrict && (!this.consumeTime || !this.consumeTime[0] || !this.consumeTime[1])) {
      this.$message.warning('请选择消费时段');
      return;
    }
    if (showConfirm) {
      this.$confirm('当前抽取人数大于商品库存数，确定抽取?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning',
      }).then((res) => {
        if (res == 'confirm') {
          this.isShowConfirm = true;
        }
      }, noop);
    } else {
      this.isShowConfirm = true;
    }
  }

  /**
   * 确认抽取
   */
  public onConfirmChouQu() {
    this.$refs.form.validate((result) => {
      if (result) {
        this.chouQuLoading = this.$loading({
          lock: true,
          text: '请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(225, 225, 225, 0.3)',
        });
        const postParams = {
          actId: this.choosedActId || 0, // 活动ID
          orderCheck: this.targetOrderCheck, // 报名时填入的规格选项 1限制 2不限制

          cCstLevelCode: this.selectLevel, // 会员等级
          hideActs: this.excludedActivityList, // 需要过滤的活动
          chooseRadios: [], // A19.活动对应报名信息的筛选项(发送抽中通知用到) 此接口选中的值
          orderBeginTime: this.isOpenActTimeFilter ? (this.isAstrict ? moment(this.consumeTime[0]).unix() : 0) : 0,
          orderEndTime: this.isOpenActTimeFilter ? (this.isAstrict ? moment(this.consumeTime[1]).unix() : 0) : 0,
          tableName: this.tableName,
          sendToId: this.sendToId,
        };
        if (this.targetOrderCheck == 2) {
          postParams['getNumber'] = this.getNumber;
        } else if (this.targetOrderCheck == 1) {
          postParams['getNumbers'] = this.orderSkuItems.map((item: ItemObject) => {
            return {
              getNumber: Number(item.choosePeopleNum),
              sku: item.sku,
              skuSpec: item.specVal,
            };
          });
        }
        const chooseRadios = [];
        this.orderFormChooseList.forEach((o) => {
          const selected = o.column_choose_valus.find(c => c.name === o.column_value);
          const selectedIndex = o.column_choose_valus.findIndex(c => c.name === o.column_value);
          selectedIndex && selected && chooseRadios.push(selected.name);
        });
        postParams.chooseRadios = chooseRadios;

        IPSService.adminActExtractionSave({ postParams })
          .then((res) => {
          })
          .catch(() => this.chouQuLoading.close());
      }
    });
  }

  /**
   * 抽中结果
   * @param val
   */
  public chooseResultChange(val): void {
    const self = this;
    this.isPostFlag = Number(val);
    const postParams = {
      actId: this.choosedActId || 0, // 活动ID
      hidePhone: 1, // 1手机号码加密
      isPost: this.isPostFlag, // 是否已发送 1发送 0木有 不传或者9代表全部
      page: 1,
      pageNum: this.chooseLengthPageNum,
    };

    if (this.targetSku) {
      postParams['sku'] = this.targetSku;
    }

    IPSService.getExtractionList({ postParams }).then((res) => {
      self.chooseResultList = res.list.map((chooseItem: any) => {
        chooseItem.orderSpec = Functions.emptyVaribleHandler(chooseItem.orderSpec);
        return chooseItem;
      });
      self.chooseResultTotal = res.count;
      self.successOrderNumber = res.unPostCount || 0;
    });
  }

  /**
   * 抽中当前页
   * @param val
   */
  public handleCNCurrentChange(val) {
    this.chooseLengthPage = val;
    this.getChooseLengthConfirm();
  }

  /**
   * 发送抽中通知弹窗
   * @return null
   */
  public ShowCodeTimeFn(): void {
    this.isShowCodeTime = !this.isShowCodeTime;
    this.valueStime = '';
    this.valueEtime = '';
  }

  /**
   * 抽中每页显示条数
   * @param val
   */
  public selectedCnPageNum(val): void {
    this.chooseLengthPageNum = val;
    this.chooseLengthPage = 1;
    this.getChooseLengthConfirm();
  }

  /**
   * 发送未抽中通知
   * @return null
   */
  public sendActNoticeN(): void {
    this.centerDialogVisible = true;
  }

  public onChangePlace(value): void {
    this.signInAddress = value;
  }

  /**
   * 发送未抽中通知
   * @return null
   */
  public sendActNoticeConfirm(): void {
    const postParams = {
      actId: this.choosedActId, // 活动ID
    };
    IPSService.unLotteryNotice({ postParams })
      .then(() => {
        this.$message.success('发送成功');
        this.chooseResult = false;
        this.dialogVisible_chooseLength = false;
        this.dialogVisible_chooseLength_hasRule = false;
        this.centerDialogVisible = false;
        this.getActivityList();
      })
      .catch(function(err) {
        this.$message.error(err);
      });
  }

  /**
   * 禁用/启用 操作
   * @param id
   * @param type
   */
  public onChangeActState(id, type): void {
    const postParams = {
      actIdList: [id],
      state: type,
    };
    this.updateActivityState(postParams);
  }

  /**
   * 改变活动状态 下架/上架 api
   * @param postParams
   */
  updateActivityState(postParams) {
    IPSService.updateActivityStatus({ postParams }).then((res) => {
      if (res.ret) {
        this.$message.success('操作成功');
        if (!isEmpty(this.requestParam.actTypeId)) {
          this.requestParam.page = 1;
          this.page = 1;
        }
        this.getActivityList();
      } else {
        this.$message.error('操作失败');
      }
    });
  }

  // 编辑活动展示
  editAct(actId) {
    this.editActShow = true;
    IPSService.getActivityPicInfo({ postParams: { actId } }).then((res) => {
      this.editActContent = res;
      this.actDetailPics = res?.actDetailPics?.map(v => v.pic);
    });
  }
  uploadImagesSuccess(val, type) {
    type ? this.actDetailPics = val : this.editActContent.actCover = val;
  }

  // 上传活动图片
  changeActImage() {
    if (!this.editActContent?.actCover) {
      this.$message.error('请上传活动封面！');
      return;
    }
    const addArr= this.actDetailPics.filter(v=>(this.editActContent.actDetailPics.findIndex(item=>item.pic===v)===-1))
    const sliceArr=this.editActContent.actDetailPics.filter(v=>(!this.actDetailPics.includes(v.pic)))
    addArr.map((v)=>{
      this.editActContent.actDetailPics.push({ pic: v, words: '' })
    })
    sliceArr.map((v)=>{
      this.editActContent.actDetailPics.splice(this.editActContent.actDetailPics.findIndex(item=>item.pic===v.pic), 1)
    })
    this.editActContent.actDetailPics.sort((pre, next)=>{ return this.actDetailPics.indexOf(pre.pic) - this.actDetailPics.indexOf(next.pic) })
    IPSService.getActivityPicSave({ postParams: { ...this.editActContent } }).then((res) => {
      if (res.result) {
        this.$message.success('上传成功！');
        this.editActShow = false;
      }
    });

  }

  /**
   * 二维码预览
   * @param {number} id
   * @return null
   */
  public onGetCodeUrl(id: number): void {
    const queryParams = {
      actId: id,
    };
    IPSService.getActivityPreview({ queryParams })
      .then((res) => {
        if (isset(res, 'actUrl')) {
          this.isShowCode = true;
          this.imageView = res.actUrl;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  /**
   * 活动抽签
   * @return null
   */
  public onChouQu(row) {
    this.resetSocket();
    this.chouQuCount = '0';
    this.chouQuNumber = 0;
    // orderCheck==2规格不限制
    if (row.isSendUnLotteryMsg) {
      return false;
    }
    this.targetOrderCheck = row.orderCheck;
    this.choosedActId = row.actId;
    this.chooseSiteId = row.siteId;
    IPSService.siteGroupConfig({ postParams: { siteId: row.siteId } }).then((result) => {
      this.isOpenActTimeFilter = result.isOpenActTimeFilter === 1;
      this.isCustomerScreen = !!result.isCustomerScreen;
      this.maxNumber = result.isCustomerScreen || 0;
      if (row.orderCheck == 2) {
        this.isCanChou = true;
        this.dialogVisible_chooseLength = !this.dialogVisible_chooseLength;
        this.isSendUnLotteryMsg = !!(row.isSendUnLotteryMsg || 0);
        this.isSendLotteryMsg = !!(row.isSendLotteryMsg || 0);
        this.adminActOrderChooseList();
        this.getOtherActivityList(); // 获取该店铺其他活动的列表
        this.getLevelList();
        const postParams = { actId: Math.trunc(this.choosedActId) }; // 活动ID
        IPSService.getExtractionNum({ postParams })
          .then((res) => {
            this.extrationNumData = Object.assign({}, { siteCode: row.siteCode }, res);
            this.selectedCoupon = { cplId: this.extrationNumData.cplId, cplName: this.extrationNumData.cplName };
            this.signInAddress = res.siteAddress;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.ruleSkId = row.skId;
        this.getRuleList();
        this.isCanChou = true;
        this.dialogVisible_chooseLength_hasRule = !this.dialogVisible_chooseLength_hasRule;
        this.isSendUnLotteryMsg = !!(row.isSendUnLotteryMsg || 0);
        this.isSendLotteryMsg = row.isSendLotteryMsg || 0;
        this.adminActOrderChooseList();
        this.getOtherActivityList(); // 获取该店铺其他活动的列表
        this.getLevelList();
        const postParams = { actId: Math.trunc(this.choosedActId) }; // 活动ID
        IPSService.getExtractionNum({ postParams })
          .then((res) => {
            this.extrationNumData = Object.assign({}, { siteCode: row.siteCode }, res);
            this.selectedCoupon = { cplId: this.extrationNumData.cplId, cplName: this.extrationNumData.cplName };
            this.signInAddress = res.siteAddress;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }

  /**
   * 发送抽中通知
   * @return null
   */
  public sendActNotice(): void {
    const st = Number(this.valueStime.valueOf()) / 1000;
    const et = Number(this.valueEtime.valueOf()) / 1000;
    if (et <= st) {
      this.$message.error('结束必须大于开始时间');
      return;
    }
    if (!this.signInAddress) {
      this.$message.error('请输入签到地点');
      return;
    }
    const postParams = {
      actId: this.choosedActId, // 活动ID
      beginTime: st, // 取号开始时间
      endTime: et, // 取号结束时间
      signInAddress: this.signInAddress, // 签到地点
      cplId: this.selectedCoupon.cplId,
    };
    this.$confirm(`发送抽中人数${this.successOrderNumber}人？`, '请确认人数是否准确', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      IPSService.actNotice({ postParams })
        .then(() => {
          this.$message.success('发送成功');
          this.chooseResult = false;
          this.dialogVisible_chooseLength = false;
          this.isShowCodeTime = false;
          this.getActivityList();
        })
        .catch(function(err) {
          this.$message.error(err);
        });
    }, noop);
  }

  /**
   * 批量操作：0下架，1上架
   * @param {number} type
   */
  onBatchOperation(type: number): void {
    const actIdList = collect(this.multipleSelection).pluck('actId').toArray();
    const postParams = {
      actTypeId: this.actType.actTypeId,
      actIdList,
      state: type,
    };
    this.updateActivityState(postParams);
  }

  /**
   * 获取该店铺其他活动列表
   * @return null
   */
  public getOtherActivityList(): void {
    this.otherActivityList = [];
    this.excludedActivityList = [];
    const queryParams = {
      actId: this.choosedActId, // 活动ID
    };
    IPSService.getOtherActivityList({ queryParams })
      .then((res) => {
        // 已经选中的
        if (res.list.length > 0) {
          res.list.forEach((item) => {
            if (item.isSelect === 1) {
              this.excludedActivityList.push(item.actId);
            }
          });
        }
        this.otherActivityList = res.list;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.platformVersion = localStorage.getItem('platformVersion');

    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-ACTIVITY-INNER');
    if (this.isContentBodyShow) {
      this.defaultStart = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
      this.defaultEnd = new Date(Date.now());
      this.date = [this.defaultStart, this.defaultEnd];
      this.getActivityList();
      this.getActTypeList(); // 获得活动类型列表
      // this.getRuleList();
    }
    this.resetSocket();
  }

  // 创建连接
  public createSocket(sendToId?) {
    setTimeout(() => {
      console.log('socket建立连接');
      this.$socket.connect(); // socket建立连接
      this.onSokectConnect(sendToId); // 打开socket
    }, 1500);
    // 由于socket重新连接需要时间，所以延迟
    setTimeout(() => {
      this.isSocketReady = true;
    }, 1500);
  }

  // 重启socket
  public resetSocket() {
    this.isSocketReady = false;
    this.closeSockets();
    //  this.sendToId=uuidv4()
    this.sendToId = `${appEnvConfig.NODE_ENV}InnerActivityManage${this.$store.state.empCode}`;
    this.createSocket(this.sendToId);
  }

  /**
   * 连接socket 生成消息体
   * @return null
   */
  public onSokectConnect(sendToId): void {

    this.$socket.emit('login', sendToId); // 发送信息给服务端
    this.sockets.subscribe('new_msg', (msg) => {
      if (msg) {
        const msgArr = msg.split('|');
        //  if (this.dialogVisible_chooseLength_hasRule || this.dialogVisible_chooseLength) {
        if (msgArr[0] === 'success') {
          // 导出成功
          if (msgArr[msgArr.length - 2] == 1) {
            const qiniuUrl = msgArr[3];
            this.exportBtnInfo = {
              state: 2,
              url: qiniuUrl || `${appEnvConfig.IPS_NODE_URLS}/file/download?fileUrl=${msgArr[1]}`,
            };
          }
          // 导入成功 第二位为成功条数
          if (msgArr[msgArr.length - 2] == 0) {
            this.memberNum = Number(msgArr[1]);
            this.isUploadOver = true;
            this.uploadLoading = false;
            // this.tableName = msgArr[msgArr.length - 1];
          }
        } else {
          this.exportBtnInfo = {
            state: 0,
            url: '',
          };
          //  }
        }

        if (this.isShowConfirm) {
          // 成功的
          if (msgArr[0] === 'success') {
            this.chouQuLoading && this.chouQuLoading.close();
            this.getRuleList();
            this.getChooseLengthConfirm();
            this.getActivityList();
            this.chooseResult = true;
            this.dialogVisible_chooseLength_hasRule = false;
            // 抽取中的
          } else if (msgArr[0] === 'loading') {
            this.chouQuNumber += Number(msgArr[2]);
            this.chouQuCount = msgArr[3];
            const text: string = msgArr[2] === '0' ? '请稍等' : `当前进度${this.chouQuNumber}/${this.chouQuCount}`;
            this.chouQuLoading.setText(text);
            // 抽取出错的
          } else {
            this.chouQuLoading && this.chouQuLoading.close();
            this.$message.warning(`总人数${this.chouQuCount},共抽取${this.chouQuNumber}`);
            this.getRuleList();
            this.getChooseLengthConfirm();
            this.getActivityList();
            this.chooseResult = true;
            this.dialogVisible_chooseLength_hasRule = false;
          }
        }
      }
    });
  }

  closeSockets() {
    this.sockets.unsubscribe('new_msg'); // 取消订阅
    this.$socket.disconnect(); // 断开连接
  }

  /**
   * A19.活动对应报名信息的筛选项(发送抽中通知用到)
   */
  public adminActOrderChooseList() {
    const me = this;
    const postParams = {
      actId: this.choosedActId, // 活动ID
      // actId: 459,//活动ID
    };
    IPSService.adminActOrderChooseList({ postParams }).then((res) => {
      me.orderFormChooseList = res.list;
      res.skuItems.map((item, index) => {
        item['choosePeopleNum'] = '';
      });
      me.orderFormChooseList.map((item, index) => {
        item.column_choose_valus.splice(0, 0, { name: '不限' });
        me.enlistParam.chooseRadios[index] = item.column_choose_valus[0].name;
        return Object.assign({}, item, { column_value: item.column_value || '' });
      });
      me.orderSkuItems = res.skuItems;
    });
  }

  /**
   * 会员等级
   */
  public getLevelList() {
    const me = this;
    const postParams = {
      actId: this.choosedActId, // 活动ID
    };
    IPSService.adminActCstLevelList({ postParams }).then((res) => {
      const baseLevelList = [{ cstLevelCode: '', cstLevelName: '全部' }];
      me.levelList = baseLevelList.concat(res.list);
    });
  }

  /**
   * 报名规格筛选
   * @param value
   */
  public ruleChange(value) {
    // this.getRuleList();

    this.targetSku = value;
    this.getChooseLengthConfirm();
  }

  /**
   * 报名规格筛选
   * @param e
   */
  public getRuleList() {
    // let me=this;
    IPSService.adminGoodsSkidList({ postParams: { skId: this.ruleSkId } })
      .then((res: ItemObject) => {
        if (res && !res.skuItems) {
          this.$message.error('参数错误！');
          return false;
        }

        res.skuItems.map((item) => {
          item.sold = item.totalStock - item.hasStock;
          const proportion1 = item.totalStock > 0 ? (item.sold * 100) / item.totalStock : 0;
          item.proportion = proportion1 > 0 ? `${proportion1.toFixed(2)}%` : '0%';
          item = Object.assign({}, item);

          return item;
        });
        this.ruleList = res.skuItems;
      })
      .catch(() => {
      });
  }

  /**
   * 报名列表筛选 （会员等级）
   * @param e
   */
  public cstLevelChange(e) {
    this.getEnlist();
  }

  /**
   * 报名列表筛选 （单选列表）
   * @param e
   */
  public radiosChange(e, index) {
    // if(e==this.enlistParam.chooseRadios[0]){
    this.getEnlist();
    // }else{
    //     this.$message.warning("未检索到相应尺寸");
    // }
  }

  /**
   * 下载文件
   * @return null
   */
  public onDownLoadFile(): void {
    location.href = this.exportBtnInfo.url;
    setTimeout(() => {
      this.exportBtnInfo = {
        state: 0,
        url: '',
      };
    }, 2000);
  }

  /**
   * 打开当前规格抽中结果
   */
  public openChoosedResult(item) {
    this.targetSku = item.sku;
    this.chooseResult = !this.chooseResult;
    this.getRuleList();
    this.getChooseLengthConfirm();
  }

  public choosePeopleNumFn(el, item) {
    if (el > item.totalStock) {
      item.choosePeopleNum = item.totalStock;
      this.$message.warning('抽取数量应小于发售库存');
    }
    // 待续。。。。
  }

  /**
   * 文件上传之前
   * @param {any} file
   * @returns null
   */
  public onBeforeUpload(file) {
    const fileType = file.name.slice(Math.max(0, file.name.lastIndexOf('.') + 1));
    const extension2 = fileType === 'xlsx';
    this.fileName = file.name;
    this.importFile = file;
    let result = true;
    if (!extension2) {
      this.$message({
        message: '上传文件只能是 xls、xlsx、excel格式!',
        type: 'warning',
      });
      result = false;
    }
    return result;
  }

  // 上传成功
  public uploaduccess() {
  }

  // 上传失败
  public uploadError() {
    this.$message.error('请重新选择文件');
  }

  // 导入
  public onImport() {
    this.uploadLoading = true;
    const fileFormData = new FormData();
    fileFormData.append('sendToId', `${appEnvConfig.NODE_ENV}MemberScreen${this.$store.state.empCode}`);
    fileFormData.append('file', this.importFile, this.fileName);
    fileFormData.append('actDataId', `${this.choosedActId}`);
    axios({
      url: `nips/admin/customer/info/import?corpId=${this.corpId}`,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': this.tokenData.Authorization,
      },
      data: fileFormData,
    }).then((result) => {
    });
  }

  // 下载模板
  public downloadTemplate() {
    Functions.excelMaker({
      columns: [{ header: '顾客ID', key: 'customerId', width: 40 }],
      data: [{}],
      name: '可中签用户模板',
    });
  }

  public onOpenScreen() {
    customerScreen
      .open({
        actId: this.choosedActId,
        siteId: this.chooseSiteId,
        maxNumber: this.maxNumber,
        sendToId: `${appEnvConfig.NODE_ENV}MemberScreen${this.$store.state.empCode}`,
      })
      .then((result) => {
        this.tagList = result.tagList;
        this.tableName = result.tableName;
      }, noop);
  }

  /**
   * 选择优惠券
   */
  public onSelectCoupon() {
    couponLink.open({
      siteCodes: [this.extrationNumData.siteCode],
      params: { cpnType: 6, isIps: 1 },
    }).then((result) => {
      const { id, name } = result;
      this.selectedCoupon = { cplId: id, cplName: name };
    }, noop);
  }

  /**
   * 周期函数
   */
  mounted() {
    this.enlistParam.chooseRadios.map((item) => {
      return '不限';
    });
  }

  beforeDestroy() {
    this.closeSockets();
  }
}
